import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import {lazyRetry} from "game_play/utils";
import Big_round_5 from "game_play/model/big_round_5";
import * as ViewBigRound from "./component/big_round";
import { Modal } from "championship/src/components/Modal";
import ScoreTableBtn from "./component/scoreTableBtn";
import CommonLogic from "./component/CommonLogic";

const GameView501 = React.lazy(() => lazyRetry(() => import("./component/501"), '501'));
const GameView301 = React.lazy(() => lazyRetry(() => import("./component/301"), '301'));
const GameView601 = React.lazy(() => lazyRetry(() => import("./component/601"), '601'));
const GameView1001 = React.lazy(() => lazyRetry(() => import("./component/1001"), '1001'));
const GameViewScore = React.lazy(() => lazyRetry(() => import("./component/score"), 'score'));
const GameViewCricket = React.lazy(() => lazyRetry(() => import("./component/cricket"), 'cricket'));
const GameViewCricketAmerican = React.lazy(() => lazyRetry(() => import("./component/cricket_american"), 'cricket_american'));
const GameViewSector = React.lazy(() => lazyRetry(() => import("./component/sector"), 'sector'));
const GameViewBigRound = React.lazy(() => lazyRetry(() => import("./component/big_round"), 'big_round'));

Sentry.init({
  dsn: "https://5dcb759925774255ba8a919ab228d8ae@o38570.ingest.sentry.io/6671957",
  // integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV === 'production',
});

let App = () => null
if (window.INIT_DATA.type_game === '501') {
  App = GameView501
}
if (window.INIT_DATA.type_game === '301') {
  App = GameView301
}
if (window.INIT_DATA.type_game === '601') {
  App = GameView601
}
if (window.INIT_DATA.type_game === '1001') {
  App = GameView1001
}
if (window.INIT_DATA.type_game === 'score') {
  App = GameViewScore
}
if (window.INIT_DATA.type_game === 'cricket') {
  App = GameViewCricket
}
if (window.INIT_DATA.type_game === 'cricket_american') {
  App = GameViewCricketAmerican
}
if (window.INIT_DATA.type_game === 'sector') {
  App = GameViewSector
}
if (window.INIT_DATA.type_game === 'big_round') {
  App = GameViewBigRound
}
if (window.INIT_DATA.type_game === 'big_round_5') {
  App = ViewBigRound.fabricModalView({
    Game: Big_round_5
  })
}

function GameView() {
  return (
    <React.Suspense fallback={<>...</>}>
      <App/>
      <CommonLogic></CommonLogic>
    </React.Suspense>
  )
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<GameView/>);